import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getBusiness } from "constants/apiUrls";

// Update business payload type
export interface UpdateBusinessPayload {
  name?: string;
  address?: {
    address1?: string;
    address2?: string;
    zipCode?: string;
    state?: string;
    stateShortCode?: string;
    country?: string;
    countryShortCode?: string;
    city?: string;
  };
  logo?: string | null;
  website?: string;
  phoneNumber?: string[];
  categories?: string[];
  openExternalLinks?: Array<{
    metaExternalLinkUuid: string;
    url: string;
  }>;
  businessOpeningHours?: Array<{
    day: number;
    startTime: string;
    endTime: string;
  }>;
  businessHourNotes?: string;
  photosData?: {
    deletedPhotos?: string[];
    newPhotos?: string[];
  };
}

const businessApi = createApi({
  reducerPath: "business",
  baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_SERVER_URL }),
  tagTypes: ['Business'],
  endpoints: (builder) => ({
    business: builder.query<BusinessType, { token?: string; uuid: string }>({
      query: (arg) => {
        const { token, uuid } = arg;
        const mandatoryHeaders = {
          "bludot-app-name": "business-rewards",
          "Content-Type": "application/json",
          Authorization: `Bearer ${
            token || JSON.parse(localStorage.getItem("token") || "")
          }`,
        };
        return {
          // Add ?persona=business to get full business data including photos
          url: `${getBusiness(uuid)}?persona=business`,
          headers: mandatoryHeaders,
        };
      },
      transformResponse: (response: any) => {
        // Handle wrapped response (result field) or direct response
        return response?.result || response;
      },
      providesTags: ['Business'],
    }),
    
    updateBusiness: builder.mutation<any, { uuid: string; data: UpdateBusinessPayload }>({
      query: ({ uuid, data }) => {
        const token = JSON.parse(localStorage.getItem("token") || '""');
        return {
          url: `${getBusiness(uuid)}?persona=business`,
          method: "PATCH",
          headers: {
            "bludot-app-name": "business-rewards",
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          },
          body: data,
        };
      },
      invalidatesTags: ['Business'],
    }),
  }),
});

export const { useBusinessQuery, useLazyBusinessQuery, useUpdateBusinessMutation } = businessApi;
export default businessApi;
